export const COLUMNS = [
  {
    Header: "Code",
    accessor: "TermCode",
    sortType: (a, b) => {
      const aVal = parseInt(a.original.TermCode, 10) ?? a.original.TermCode;
      const bVal = parseInt(b.original.TermCode, 10) ?? b.original.TermCode;

      if (aVal > bVal) return 1;
      if (bVal > aVal) return -1;
      return 0;
    }
  },
  {
    Header: "Description",
    accessor: "TermDescription"
  },
  {
    Header: "Days",
    accessor: "TermDays"
  },
  {
    Header: "Discount",
    accessor: "TermDiscount"
  },
  {
    Header: "Active",
    accessor: "Active",
    Cell: ({ cell }) => (cell.value ? "Yes" : "No")
  }
];
